import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, Observable, of } from 'rxjs';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpClient, private configService: ConfigService) {}

  public IsAuthenticated: boolean;
  private tokenSubject = new BehaviorSubject<string | null>(null);

  public async signIn(body: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.http.post<any>(`api/auth`, body).subscribe({
        next: (res: any) => {
          this.IsAuthenticated = true;
          resolve();
        },
        error: () => {
          reject();
        },
      });
    });
  }

  public setToken(token: string | null): void {
    this.tokenSubject.next(token);
  }

  public getToken(): Observable<string | null> {
    return this.tokenSubject.asObservable();
  }

  public isAuthenticatedAsync(): Observable<boolean> {
    return this.http
      .post<any>(
        `${this.configService.server}api/auth/refresh`,
        {},
        { withCredentials: true }
      )
      .pipe(
        map(() => true),
        catchError(() => {
          return of(false);
        })
      );
  }

  public signOut(): void {
    this.http
      .post<any>(`${this.configService.server}api/auth/sign-out`, {})
      .subscribe({
        next: () => {
          this.IsAuthenticated = false;
        },
        error: () => {
          console.log('sign out error');
        },
      });
  }
}
